// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"353":"9de7dfe9","828":"a9402fc1"}[chunkId] + ".css";
};